import React, { useRef, useState } from 'react'
import Slider from 'react-slick';
import Video from '../Other/Video';

const SliderTestimoni = () => {
    const video = useRef(null)
    const [play, setPlay] = useState(false)

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const slider1 = useRef(null);

    const previous = () => {
        slider1.current.slickNext();
    };

    const next = () => {
        slider1.current.slickPrev();
    };
    return (
        <Slider ref={slider1} {...settings} className="wrapper__slider-testimonial">
            <div className="items">
                <div className="row">
                    <div className="col-lg-6 order-lg-1 order-12 my-auto">
                        <Video />
                    </div>
                    <div className="col-lg-6 order-1 order-lg-12 mb-4 my-lg-auto">
                        <div className="wrapper__card-text-testi text-center position-relative">
                            <img src="./../images/sd (1).png" className='bg' alt="" />
                            <div className="position-relative about z-2">
                                <h5 className='semi-bold font__size--24 text__24-1024 text__24-sm text__24-xs color__white mb-4'>I love my new plant from Bloom & Grow! The staff was so helpful in helping me choose the perfect plant for my home.</h5>

                                <img src="./../images/Vector (1).png" alt="" />
                                <p className='semi-bold font__size--20 text__20-1024 color__white mt-2'>John Doni</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="items">
                <div className="row">
                    <div className="col-lg-6 order-lg-1 order-12 my-auto">
                        <Video />
                    </div>
                    <div className="col-lg-6 order-1 order-lg-12 mb-4 my-lg-auto">
                        <div className="wrapper__card-text-testi text-center position-relative">
                            <img src="./../images/sd (1).png" className='bg' alt="" />
                            <div className="position-relative about z-2">
                                <h5 className='semi-bold font__size--24 text__24-1024 text__24-sm text__24-xs color__white mb-4'>I love my new plant from Bloom & Grow! The staff was so helpful in helping me choose the perfect plant for my home.</h5>

                                <img src="./../images/Vector (1).png" alt="" />
                                <p className='semi-bold font__size--20 text__20-1024 color__white mt-2'>John Doni</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="items">
                <div className="row">
                    <div className="col-lg-6 order-lg-1 order-12 my-auto">
                        <Video />
                    </div>
                    <div className="col-lg-6 order-1 order-lg-12 mb-4 my-lg-auto">
                        <div className="wrapper__card-text-testi text-center position-relative">
                            <img src="./../images/sd (1).png" className='bg' alt="" />
                            <div className="position-relative about z-2">
                                <h5 className='semi-bold font__size--24 text__24-1024 text__24-sm text__24-xs color__white mb-4'>I love my new plant from Bloom & Grow! The staff was so helpful in helping me choose the perfect plant for my home.</h5>

                                <img src="./../images/Vector (1).png" alt="" />
                                <p className='semi-bold font__size--20 text__20-1024 color__white mt-2'>John Doni</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Slider>

    )
}

export default SliderTestimoni